export type ProductSummaryLayoutStyle = 'normal' | 'medium' | 'large';

export interface ProductSummaryMediaDimensions {
  desktopWidth: number;
  desktopHeight: number;
  mobileWidth: number;
  mobileHeight: number;
}

export const PRODUCT_SUMMARY_MEDIA_DIMENSIONS: Record<ProductSummaryLayoutStyle, ProductSummaryMediaDimensions> = {
  normal: {
    desktopWidth: 544,
    desktopHeight: 544,
    mobileWidth: 390,
    mobileHeight: 292,
  },
  medium: {
    desktopWidth: 560,
    desktopHeight: 420,
    mobileWidth: 326,
    mobileHeight: 244.5,
  },
  large: {
    desktopWidth: 708,
    desktopHeight: 708,
    mobileWidth: 390,
    mobileHeight: 390,
  },
};

export const isEasycraftProductSummary = (blockType: string) => blockType === 'easycraft.productSummary';

export const resolveProductSummaryLayoutStyle = (
  blockType: string,
  layoutStyle?: ProductSummaryLayoutStyle,
): ProductSummaryLayoutStyle => {
  if (!isEasycraftProductSummary(blockType)) return 'normal';

  return layoutStyle === 'medium' || layoutStyle === 'large' ? layoutStyle : 'normal';
};
